import React, { useContext, useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon } from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from 'react-loader-spinner';
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { LocaleContext } from '../../components/LocaleContext';
import { createAsyncNavigateHandlers } from '../../utils/asyncArrayNavigate';
import { cleanSorters } from '../../utils/tabulatorProgressiveLoading';
import { getTemperature, getWeatherLocationForApi } from '../../utils/moduleSettings';
import {
  convertTemperature,
  paintingTempsToDisplay,
  paintingTempsToStorage,
} from '../../utils/formatters';

export default function PaintingConditionAdd({ painting_condition, type, listFilters = [], listSorters = [] }) {

    const [state, dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const [closeTab,setCloseTab] = useState(false);
    const submitRef = useRef(null);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView} = useContext(UtilContext);
  const { t } = useContext(LocaleContext);

    const [formPaintingCondition,setFormPaintingCondition] = useState(painting_condition);
    const [formType, setFormType] = useState(type);
    const [checkTimeCondition, setCheckTimeCondition] = useState(false);

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add painting"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit painting"))?false:true);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [favoriteVisible,setFavoriteVisible] = useState(false);
    const [favoriteGroupValue,setFavoriteGroupValue] = useState("");
    const [favoriteValue,setFavoriteValue] = useState("");

    // Pri edit načítaj záznam z API (manuál 4.12)
    useEffect(() => {
        if (type !== 'edit' || !painting_condition?.id) return;
        getRequest(`/api/painting_conditions/${painting_condition.id}`)
            .then((res) => {
                const data = res?.data?.data ?? res?.data ?? res;
                if (data && typeof data === 'object') {
                    const unit = getTemperature(state.module_settings);
                    setFormPaintingCondition(paintingTempsToDisplay(data, unit));
                }
            })
            .catch(() => {});
    }, [type, painting_condition?.id]);

    function addNewPaintingCondition(){
        dispatch({ type: 'create_new_tab', name: t('PaintingCondition.Tab.Add'), translationKey: 'PaintingCondition.Tab.Add', legacyLabel: t('PaintingCondition.Tab.Add'), page: 'PaintingConditionAdd', props: { painting_condition: null, type: 'add', listFilters, listSorters }, mask: 'pain003' });
    }

    function copyPaintingCondition(){
        dispatch({ type: 'create_new_tab', name: t('PaintingCondition.Tab.Add'), translationKey: 'PaintingCondition.Tab.Add', legacyLabel: t('PaintingCondition.Tab.Add'), page: 'PaintingConditionAdd', props: { painting_condition: formik.values, type: 'copy', listFilters, listSorters }, mask: 'pain003' });
    }

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    useEffect(() => {
        if(type=="add" && !checkTimeCondition){
            setCheckTimeCondition(false);
            setDialogText("Overujem podmienky");
            setVisible(true);
            getRequest(`/api/painting_conditions/checkTimeConditions`)
            .then((response) => {
                if(response.status == 200){
                    setVisible(false);
                }
                else{
                    dispatch({type:'close_tab',id:state.selectedTab});
                    setVisible(false);
                    alert(t('Painting.OutsideInterval'));   
                }
            }).catch((reason) => {
                setVisible(false);
                alert(t('Painting.ConditionCheckFailed'));
            })
        }
      },[type,checkTimeCondition]);

    const formik = useFormik({
        initialValues: formPaintingCondition==null?{
            outdoor_temp: '',indoor_temp:'',outdoor_hum:'',indoor_hum:'',weather:'',ph_probe:'OK',ph_phosphate:'OK',note:'',temp_check:'OK',nacl_check:'OK',state:'',
        }:formPaintingCondition,
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            //let ph_phosphate = state.painting_intervals.filter(interval => interval.id==values.ph_phosphate);
            //let temp_check = state.painting_intervals.filter(interval => interval.id==values.temp_check);
            if(values.ph_probe=='OK' && values.nacl_check=='OK' && values.ph_phosphate=='OK' && values.temp_check=='OK'){
                values.state='OK';
            }
            else {
                values.state='NOK';
            }
            const unit = getTemperature(state.module_settings);
            const payload = paintingTempsToStorage({ ...values }, unit);
            for (let value in payload) {
                formData.append(value, payload[value]);
            }
            if(formType=="add"){
                postRequest('/api/painting_conditions', formData,true)
                .then((response) => {
                    const created = response?.data?.data ?? response?.data ?? response;
                    if(closeTab) dispatch({type:'close_tab',id:state.selectedTab});
                    if(created?.id) {
                        formik.setValues(paintingTempsToDisplay(created, unit));
                        setFormType("edit");
                    }
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
            else{
                postRequest(`/api/painting_conditions/update/${formik.values.id}`, formData,true)
                .then((response) => {
                    const updated = response?.data?.data ?? response?.data ?? response;
                    if(closeTab) dispatch({type:'close_tab',id:state.selectedTab});
                    if(updated?.id) formik.setValues(paintingTempsToDisplay(updated, unit));
                    else formik.setValues(values);
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
        },
    });

    function loadOutdoorWeather() {
        const key = '24110dc31c01b76eeef9d9264d0483e8';
        const loc = getWeatherLocationForApi(state.module_settings);
        const params = new URLSearchParams({ units: 'metric', lang: 'sk', appid: key });
        if (loc.query) {
            params.set('q', loc.query);
        } else {
            params.set('lat', String(loc.lat));
            params.set('lon', String(loc.lon));
        }
        fetch(`https://api.openweathermap.org/data/2.5/weather?${params.toString()}`)
        .then(function(resp) { return resp.json() }) // Convert data to json
        .then(function(data) {
          const unit = getTemperature(state.module_settings);
          const displayTemp = convertTemperature(data.main.temp, '°C', unit);
          formik.setFieldValue("outdoor_temp", displayTemp == null ? '' : Math.round(displayTemp));
          formik.setFieldValue("outdoor_hum",Math.round(data.main.humidity));
        })
        .catch(function() {
          // catch any errors
        });
    }

    const toParams = useCallback(() => {
        const raw = cleanSorters(listSorters);
        const sorters = raw.length ? raw : [{ field: 'created_at', dir: 'desc' }];
        const params = new URLSearchParams();
        params.set('sorters', JSON.stringify(sorters));
        (listFilters || []).forEach((f) => {
            if (f?.field != null && f.value != null && String(f.value).trim() !== '') {
                params.set('filter_' + f.field, String(f.value).trim());
            }
        });
        return params.toString();
    }, [listFilters, listSorters]);

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const buildFetchRecord = (paramsFn) => async (direction, currentId) => {
            setDialogText?.(t('Common.Loading'));
            setVisible?.(true);
            try {
                const q = paramsFn();
                const url = `/api/painting_conditions/prev_next?direction=${direction}${currentId ? '&id=' + currentId : ''}${q ? '&' + q : ''}`;
                const resp = await getRequest(url);
                const data = resp?.data ?? resp;
                if (direction === 'first' || direction === 'last') return data?.current ?? null;
                if (direction === 'prev') return data?.prev ?? null;
                if (direction === 'next') return data?.next ?? null;
                return null;
            } finally {
                setVisible?.(false);
            }
        };
        const setHydrated = (row) => {
            if (!row || typeof row !== 'object') {
                setFormPaintingCondition(row);
                return;
            }
            const unit = getTemperature(state.module_settings);
            setFormPaintingCondition(paintingTempsToDisplay(row, unit));
        };
        return createAsyncNavigateHandlers(buildFetchRecord(toParams), setHydrated, () => formPaintingCondition?.id ?? formik.values?.id);
    }, [toParams, formPaintingCondition?.id, formik.values?.id, setDialogText, setVisible, state.module_settings]);

    return (

        <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewPaintingCondition()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyPaintingCondition()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => openFavoriteDialog(t('PaintingCondition.Tab.Add'),"PaintingConditionAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => setFastView("PaintingConditionAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
        </div>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col overflow-x min-h-[calc(100vh-177px)]">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">
                   PODMIENKY LAKOVANIA
                </h1>
                <div className='flex flex-row m-auto justify-left mt-2'>
                    <div className='mr-2'>
                    <button type="button" onClick={() => loadOutdoorWeather()} className='wrapIconFill flex flex-row border mt-1 border-gray-400 rounded-md bg-white px-1 py-1 hover:text-white hover:!stroke-white hover:bg-blue-500 hover:border-blue-500'>
                    <svg class="w-6 h-6 text-gray-800 dark:text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-11a1 1 0 0 0 1-1V1a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1Zm0 12a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1ZM4.343 5.757a1 1 0 0 0 1.414-1.414L4.343 2.929a1 1 0 0 0-1.414 1.414l1.414 1.414Zm11.314 8.486a1 1 0 0 0-1.414 1.414l1.414 1.414a1 1 0 0 0 1.414-1.414l-1.414-1.414ZM4 10a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1Zm15-1h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2ZM4.343 14.243l-1.414 1.414a1 1 0 1 0 1.414 1.414l1.414-1.414a1 1 0 0 0-1.414-1.414ZM14.95 6.05a1 1 0 0 0 .707-.293l1.414-1.414a1 1 0 1 0-1.414-1.414l-1.414 1.414a1 1 0 0 0 .707 1.707Z"/>
                    </svg>
                    <span className='ml-2 text-xl font-light text-left'>{t('Ui.R67.Nahrat_udaje_z_internetu')}</span>
                    </button>
                    </div>
                </div>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formik.values.id}</label>}
                      <div>
                        <label
                            for="outdoor_temp"
                            className="block text-md font-semibold text-gray-800"
                        >
                            VONKAJŠIA TEPLOTA v {getTemperature(state.module_settings || [])}
                        </label>
                        <input
                            name='outdoor_temp'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.outdoor_temp}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            for="outdoor_hum"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.VONKAJSIA_VLHKOST_v')}</label>
                        <input
                            name='outdoor_hum'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.outdoor_hum}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    
                      <div>
                        <label
                            for="indoor_temp"
                            className="block text-md font-semibold text-gray-800"
                        >
                            VNÚTORNÁ TEPLOTA v {getTemperature(state.module_settings || [])}
                        </label>
                        <input
                            name='indoor_temp'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.indoor_temp}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            for="indoor_hum"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.VNUTORNA_VLHKOST_v')}</label>
                        <input
                            name='indoor_hum'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.indoor_hum}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                      <div>
                        <label
                            for="weather"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.POCASIE')}</label>
                        <select 
                        name='weather'
                        onChange={formik.handleChange} value={formik.values.weather}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="">{t('Ui.R67.Vyber_pocasie')}</option>
                            {(state.weather || []).map((weather) => 
                            <option value={weather.type} key={weather.id}>{weather.type}</option>
                            )}
                        </select>
                        </div>              
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-xl font-semibold text-left text-zinc-900">{t('Ui.R67.Priprava_pred_lakovanim')}</h1>
                      <div className="mt-6">
                        <label
                            for="ph_probe"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Kontrola_cistoty_pH_sondy')}</label>
                        <select 
                        name='ph_probe'
                        onChange={formik.handleChange} value={formik.values.ph_probe}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="OK">OK</option>
                          <option value="NOK">NOK</option>
                        </select>
                        </div>
                        <div>
                        <label
                            for="ph_phosphate"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Kontrola_pH_fosfatu')}</label>
                        <select 
                        name='ph_phosphate'
                        onChange={formik.handleChange} value={formik.values.ph_phosphate}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            {(state.painting_intervals || []).filter(interval=>interval.type=='PH').map((painting_interval) => (
                            <option key={painting_interval.id} value={painting_interval.state}>{painting_interval.name}</option>
                          ))}
                        </select>
                        </div>
                        <div>
                        <label
                            for="temp_check"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Kontrola teploty WAP
                        </label>
                        <select 
                        name='temp_check'
                        onChange={formik.handleChange} value={formik.values.temp_check}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            {(state.painting_intervals || []).filter(interval=>interval.type=='WAP').map((painting_interval) => (
                            <option key={painting_interval.id} value={painting_interval.state}>{painting_interval.name}</option>
                          ))}
                        </select>
                        </div>
                        <div>
                        <label
                            for="nacl_check"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Kontrola NaCl v sude
                        </label>
                        <select 
                        name='nacl_check'
                        onChange={formik.handleChange} value={formik.values.nacl_check}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="OK">OK</option>
                          <option value="NOK">NOK</option>
                        </select>
                        </div>
                        <div>
                        <label
                            for="note"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Note')}</label>
                        <textarea
                        name='note'
                        onChange={formik.handleChange} value={formik.values.note}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <button type="submit" ref={submitRef} className='hidden'></button>          
            </div>
            </div>
            </div>
            </form>
            </div>
            );
} 
